export enum SourceCodes {
  USERS = 'USERS',
  INSTALLATIONS = 'INSTALLATIONS',
  CENTERS = 'CENTERS',
}
